import React from 'react';
import './LoadingOverlay.css';

const LoadingOverlay = () => (
  <div className="loading-overlay">
    <div className="spinner"></div>
  </div>
);

export default LoadingOverlay;
